import * as React from 'react';
import { ICopywriter, ICopywriterLanguage } from './Entities';
import { FormGroup, FormControl, ControlLabel, HelpBlock, Row, Col } from 'react-bootstrap';
import { Translate } from '../../shared/LanguageService';
import FormValidationService from '../../shared/form/FormValidationService';
import FieldInfoIcon from '../../components/common/FieldInfoIcon';
import CountryCodePhoneNumberInput from '../../components/common/CountryCodePhoneNumberInput';
import LanguageSelect from '../../components/common/LanguageSelect';

interface IStylingUsersFormProps {
    input: ICopywriter;
    availableLanguages: any[];
    onChange: (value: any) => void;
    errors: any;
}

const CopywritersForm = (props: IStylingUsersFormProps) => {
    return (
        props.input ? 
        <Row>
            <Col md={props.input && props.input.profileImageReference ? 8 : 12}>
                <FormGroup
                    className="required"
                    validationState={FormValidationService.getValidationState(props.errors.name)}
                >
                    <ControlLabel>{Translate('copywriter/form/label-name')}</ControlLabel>
                    <FormControl
                        type="text"
                        name="name"
                        value={props.input.name ? props.input.name : ''}
                        onChange={props.onChange}
                    />
                    <HelpBlock>{props.errors.name}</HelpBlock>
                </FormGroup>
                <FormGroup
                    className="required"
                    validationState={FormValidationService.getValidationState(
                        props.errors.username
                    )}
                >
                    <ControlLabel>{Translate('copywriter/form/label-username')}</ControlLabel>
                    <FormControl
                        type="text"
                        name="username"
                        value={props.input.username ? props.input.username : ''}
                        onChange={props.onChange}
                    />
                    <HelpBlock>{props.errors.username}</HelpBlock>
                </FormGroup>
                <FormGroup
                    className="required"
                    validationState={FormValidationService.getValidationState(props.errors.email)}
                >
                    <ControlLabel>
                        {Translate('copywriter/form/label-email-address')}
                    </ControlLabel>
                    <FormControl
                        type="email"
                        name="email"
                        value={props.input.email ? props.input.email : props.input.username}
                        onChange={props.onChange}
                    />
                    <HelpBlock>{props.errors.email}</HelpBlock>
                </FormGroup>
                <FormGroup
                    validationState={FormValidationService.getValidationState(
                        props.errors.phoneNumber
                    )}
                >
                    <ControlLabel>{Translate('copywriter/form/label-phone-number')}</ControlLabel>
                    <FieldInfoIcon
                        title={Translate('popover/info/title/phonenumber')}
                        content={Translate('popover/info/content/phonenumber')}
                    />
                    <CountryCodePhoneNumberInput
                        value={props.input.phoneNumber}
                        onChange={(val) =>
                            props.onChange({
                                target: { name: 'phoneNumber', value: val }
                            })
                        }
                    />
                    <HelpBlock>{props.errors.phoneNumber}</HelpBlock>
                </FormGroup>
                <LanguageSelect
                    onChange={props.onChange}
                    languageKey={props.input.languageKey}
                    errors={props.errors}
                    languages={props.availableLanguages}
                />
            </Col>
            {props.input.profileImageReference && (
                <Col className="profile-image-preview" md={3}>
                    <img src={`/api/file/${props.input.profileImageReference}`} />
                </Col>
            )}
        </Row> : null
    );
};

export default CopywritersForm;
